import Settings from '../SettingsService'
import { BackendConnection, RefreshTokenFunctionType, BackendConnectionOptions, LoginState } from './BackendConnection';
import { postRequest } from 'core-ts/client'

export class RemoteInterface {
    private backendConnection?: Promise<BackendConnection>;
    private refreshTokenFunc: RefreshTokenFunctionType;
    
    private loginState: LoginState = { pendingLogin: false };
    private options?: BackendConnectionOptions;

    private genericServiceInfo: any = null;

    constructor(refreshTokenFunc: RefreshTokenFunctionType, options?: BackendConnectionOptions) {
        this.options = options;
        this.refreshTokenFunc = refreshTokenFunc;
        this.getBackendConnection();
    }

    private async getBackendConnection(): Promise<BackendConnection> {
        if (!this.backendConnection) {
            this.backendConnection = (async () => {
                    return new BackendConnection(
                        (await this.requestGenericService()).wss_url,
                        this.loginState,
                        this.refreshTokenFunc,
                        this.onBackendConnectionError.bind(this),
                        this.options
                    );
                })();
        }

        return this.backendConnection;
    }

    public async requestGenericService(): Promise<any> {
/*
        if(Settings.genericServiceOverride()) {
            this.genericServiceInfo = {
                ws_url: Settings.genericServiceOverride(),
                wss_url: Settings.genericServiceOverride(),
                http_url: null,
                https_url: null
            }
            return this.genericServiceInfo;
        }
*/
        console.log(`Gateway server URL: ${Settings.gatewayService()}`);
        const info = await postRequest(Settings.gatewayService(), { type: 'GET_GENERIC_SERVICE' }, null);

        if (!info || !info.wss_url) {
            throw new Error(`Failed to get generic service information: ${JSON.stringify(info)}`);
        }       
        Settings.setWebGenericService(info);
        return info;
    }

    setAccountId(id: string | undefined) {
        this.loginState.account = id;
        this.backendConnection!.then((connection) => {
            connection.setAccountId(this.loginState.account);
        }).catch((err) => {
            console.error("Failed to set account ID:", err);
        });
    }

    async request(type: string, message: any): Promise<any> {
        return (await this.getBackendConnection()).request(type, message);
    }
   
    private onBackendConnectionError (server: string) {
        console.error(`WebSocket connection error: ${server}`);
        this.backendConnection = undefined;
        this.getBackendConnection();
    }

    setPendingLogin(value: boolean) {
        this.loginState.pendingLogin = value;
        this.backendConnection!.then((connection) => {
            connection.setPendingLogin(this.loginState.pendingLogin);
        }).catch((err) => {
            console.error("Failed to set pending login:", err);
        });
    }

    async login(token?: string) {
        this.loginState.accessToken = token;
        return (await this.getBackendConnection()).login(this.loginState.accessToken);
    }

    async logout() {
        this.loginState.account = undefined;
        this.loginState.accessToken = undefined;
        return (await this.getBackendConnection()).logout();
    }

}
